var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_vm._t("dat-instances")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }